import { createActions, createState, createReducer } from 'reduxsauce-crud'


export const AdvancedSearchRedux = createActions(
  {},
  {
    prefix: 'ADVANCED_SEARCH_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = AdvancedSearchRedux
export const AdvancedSearchTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(
  INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/AdvancedSearchRedux.js